import React, {useEffect, useState} from "react";
import {FormControl, Grid, MenuItem, Select, TextField} from "@mui/material";

const CustomNumberFilter = (header, columnFilters, filterName) => {
    const [numberValue, setNumberValue] = useState(0);
    const [operator, setOperator] = useState(null);

    useEffect(() => {
        const hasFilterName = columnFilters.some(obj => {
            return obj.id.toLowerCase() === filterName
        });
        if (!hasFilterName) {
            setNumberValue(0);
            setOperator(null);
        }
        else {
            const filter = columnFilters.find(obj => obj.id.toLowerCase() === filterName.toLowerCase());
            if (filter && filter.value) {
                setNumberValue(filter.value.number || 0);
                setOperator(filter.value.operator || null);
            }
        }
    }, [columnFilters]);

    const handleInputChange = (event) => {
        setNumberValue(event.target.value);
        if (operator !== null) {
            header.column.setFilterValue({operator: operator, number: event.target.value});
        }
    };
    const handleOperatorChange = (event) => {
        const newOperator = event.target.value;
        setOperator(newOperator);
        if (numberValue !== null) {
            header.column.setFilterValue({operator: newOperator, number: numberValue});
        }
    };

    return (
        <Grid className={'pt-2'} container spacing={1} alignItems="center">
            <Grid item xs={4}>
                <FormControl fullWidth size="small">
                    <Select
                        variant={'standard'}
                        fullWidth
                        sx={{height: '1.5rem', width: '4.063rem'}}
                        value={operator}
                        onChange={handleOperatorChange}
                    >
                        <MenuItem value=">">{'>'}</MenuItem>
                        <MenuItem value=">=">{'>='}</MenuItem>
                        <MenuItem value="<">{'<'}</MenuItem>
                        <MenuItem value="<=">{'<='}</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={8}>
                <TextField
                    variant='standard'
                    value={numberValue}
                    type='number'
                    onChange={handleInputChange}
                    InputProps={{
                        style: {
                            height: '1.5rem',
                        }
                    }}
                />
            </Grid>
        </Grid>
    );
};

export default CustomNumberFilter
